module.exports = __webpack_public_path__ + "img/device-5.90a43b1a.png";